import { withAppBasePath } from 'src/utils/withAppBasePath';

import { Leaderboard } from './_types';

/**
 * Whether a manage-list row has a member-facing public leaderboard URL.
 * Hidden boards are excluded from the public index (`visible: true` on
 * {@link PublicLeaderboardsPage}); workout/calendar rows are not in this list.
 */
export function resolveLeaderboardPublicUrl(
  leaderboard: Pick<Leaderboard, 'id' | 'hidden'>
): string | null {
  if (leaderboard.hidden) {
    return null;
  }
  if (leaderboard.id == null || leaderboard.id === '') {
    return null;
  }
  return withAppBasePath(`/leaderboards/public/${leaderboard.id}`);
}

/**
 * Same path as {@link resolveLeaderboardPublicUrl} when a URL exists.
 * {@link LeaderboardShowPage} may still redirect (e.g. no divisions → `/all/all`).
 */
export function getLeaderboardPublicUrl(
  leaderboard: Pick<Leaderboard, 'id' | 'hidden'>
): string {
  const url = resolveLeaderboardPublicUrl(leaderboard);
  if (!url) {
    throw new Error('Leaderboard has no resolvable public URL');
  }
  return url;
}
